import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useDeviceRevisionsStore = defineStore('deviceRevisions', {
  state: () => ({
    data: undefined,
    options: undefined,
  }),
  getters: {
    getDeviceRevisions: (state) => state.data?.data,
    getDeviceRevisionOptions: (state) => state.options?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexDeviceRevisionOptions(params = null, silent = true) {
      if (!silent || null !== params)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params || {}, 'device_revisions', ['id', 'name', 'device_model_id']);
          const response = await axios.get('device-revisions', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexDeviceRevisions(params = {}) {
      try {
        const response = await axios.get('device-revisions', {params} );
        this.data = response.data;
        return this.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createDeviceRevision(params = {}) {
      try {
        const response = await axios.get('device-revisions/create', {params} );
        return useCreateForm('device-revisions', response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showDeviceRevision( deviceRevisionId, params = {} ) {
      try {
        const response = await axios.get(`device-revisions/${deviceRevisionId}`, {params} );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editDeviceRevision( deviceRevisionId, params = {} ) {
      try {
        const response = await axios.get(`device-revisions/${deviceRevisionId}/edit`, {params} );
        return useEditForm(`device-revisions/${deviceRevisionId}`, response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteDeviceRevision( deviceRevisionId, params = {}) {
      try {
        const response = await axios.delete(`device-revisions/${deviceRevisionId}`, {params} );
        this.options = undefined;
        toasteventbus.emit('add', {
          summary: 'Device Revision Deleted',
          detail: `Device Revision has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
